WB.Utility = WB.Utility || {};

WB.Utility.UnitUtility = function (_User) {

    this.convertTemp = function (temp) {
        return Math.round(temp) + String.fromCharCode(176);
    };

    this.convertCtoF = function (temp) {
        if (_User.Units == 2)
            return Math.round(1.8 * temp) + 32;
        return temp;
    };

    this.convertTempCtoF=function(temp)
    {
        if (_User.Units == null || _User.Units == 1)
            return Math.round(1.8 * temp) + 32 + String.fromCharCode(176);
        if(_User.Units==2)
            return Math.round(temp) + String.fromCharCode(176);
    };

    this.convertTempFtoC=function(temp)
    {
        if (_User.Units == null || _User.Units == 1)
            return Math.round(temp);
        if(_User.Units==2)
            return Math.round((temp-32)*0.55);
    };

    this.convertTempFC = function (temp) {
        if (_User.Units == null || _User.Units == 1)
            return Math.round(temp) + String.fromCharCode(176) + 'F';
        if (_User.Units == 2)
            return Math.round(temp) + String.fromCharCode(176) + 'C';
    };

    this.getTempUnits = function () {
        if (_User.Units == null || _User.Units == 1)
            return 'F';
        if (_User.Units == 2)
            return 'C';
    };

    this.convertWind = function (temp) {
        if (_User.WindUnit == null || _User.WindUnit == 1)
            return Math.round(temp);
        if (_User.WindUnit == 2)
            return Math.round(temp * 1.60934);
        if (_User.WindUnit == 3)
            return (Math.round(temp * 0.44704));
        if (_User.WindUnit == 4)
            return (Math.round(temp * 0.8689));
    };

    this.convertWindUnits = function (temp) {
        if (_User.WindUnit == null || _User.WindUnit == 1)
            return temp + ' mph';
        if (_User.WindUnit == 2)
            return (Math.round(temp * 16.0934)) / 10 + ' kph';
        if (_User.WindUnit == 3)
            return (Math.round(temp * 4.4704)) / 10 + ' m/s';
        if (_User.WindUnit == 4)
            return (Math.round(temp * 8.689)) / 10 + ' kts';
    };

    this.convertRainUnits = function (temp) {
        if (temp == null)
            return null;
        if (_User.Units == null || _User.Units == 1)
            return temp + '"';
        if (_User.Units == 2)
            return temp + 'mm';
    };

    this.convertRain = function (temp) {
        if (temp == null)
            return null;
        if (_User.Units == null || _User.Units == 1)
            return temp;
        if (_User.Units == 2)
            return Math.round(temp * 25.4);
    };

    this.getRainUnits = function () {
        if (_User.Units == null || _User.Units == 1)
            return 'in';
        if (_User.Units == 2)
            return 'mm';
    };


    this.convertMiles = function (miles, places) {
        if (_User.Units == null || _User.Units == 1)
            return miles.toFixed(places) + ' miles';
        if (_User.Units == 2)
            return (miles * 1.60934).toFixed(places) + ' km';
    };

    this.convertMkm = function (miles, places) {
        if (miles == 0)
            return '0';
        if (_User.Units == null || _User.Units == 1)
            return (miles * 1.0).toFixed(places);
        if (_User.Units == 2)
            return (miles * 1.60934).toFixed(places);
    };

    this.getWindUnits = function () {
        if (_User.WindUnit == null || _User.WindUnit == 1)
            return 'mph';
        else if (_User.WindUnit == 2)
            return 'km/h';
        else if (_User.WindUnit == 3)
            return 'm/s';
        else if (_User.WindUnit == 4)
            return 'knots';
    };

    this.convertWindMKm = function (wind) {
        return (Math.round(wind * 16.0934)) / 10;
    };

    this.convertWindKmM = function (wind) {
        return (0.62) * wind;
    };

    this.getTemp = function (temp) {
        if (_User.Units == null || _User.Units == 1)
            return Math.round(temp);
        if (_User.Units == 2)
            return Math.round((temp - 32) * 0.5555);
    };

    this.inchesToCmUnits = function (temp) {
        if (_User.Units == null || _User.Units == 1)
            return temp + '"';
        if (_User.Units == 2)
            return Math.round(temp * 2.54) + ' cm';
    };

    this.feetToMetersUnits = function (temp) {
        if (_User.Units == null || _User.Units == 1)
            return temp + ' ft';
        if (_User.Units == 2)
            return Math.round(temp * 0.3048) + ' m';
    };

    this.convertPressureUnits = function (temp) {
        if (!temp)
            return temp;
        if (_User.PressureUnit == null || _User.PressureUnit == 1)
            return temp + '"';
        if (_User.PressureUnit == 2)
            return Math.round(temp * 33.8638) + 'mb';
    };

    this.getPressureUnits = function () {
        if (_User.PressureUnit == null || _User.PressureUnit == 1)
            return 'inHg';
        if (_User.PressureUnit == 2)
            return 'mb';
    };

    this.convertPressure = function (temp) {
        if (!temp)
            return temp;
        if (_User.PressureUnit == null || _User.PressureUnit == 1)
            return temp;
        if (_User.PressureUnit == 2)
            return Math.round(temp * 33.8638);
    };

};
WB.Utility.UnitUtility.$inject = ['_User'];

WB.Core.service('UnitUtility', WB.Utility.UnitUtility);
